import Vue from 'vue'
import {SET_MEMBERSHIP, UPDATE_MEMBERSHIP, RESET_MEMBERSHIP, SET_CUSTOMER_MEMBERSHIPS} from './mutationTypes'
import MembershipsApi from '@/api/memberships'
import MEMBERSHIP_TYPES from '../../constants/membershipTypes'

export default {
  namespaced: true,
  state: {
    membershipsMap: {},
    customerMembershipOrderMap: {}
  },
  getters: {
    customerMemberships(state) {
      return customerId => {
        if (!state.customerMembershipOrderMap[customerId]) return []
        return state.customerMembershipOrderMap[customerId].map(membershipId => state.membershipsMap[membershipId])
      }
    },
    customerActiveMemberships(state) {
      return (customerId, date = new Date()) => {
        if (!state.customerMembershipOrderMap[customerId]) return []
        return state.customerMembershipOrderMap[customerId]
          .map(membershipId => state.membershipsMap[membershipId])
          .filter(m => {
            if (m.expire && new Date(m.expire) < date) return false
            if (m.type === MEMBERSHIP_TYPES.PACKAGE) {
              return m.remainingServices.length > 0
            } else {
              if (m.capacity > 0 && m.remainingVisits > 0) return true
              return m.capacity === 0
            }
          })
      }
    }
  },
  mutations: {
    [SET_MEMBERSHIP](state, membership) {
      let current = state.membershipsMap[membership._id]
      if (current) {
        Object.assign(current, membership)
      } else {
        Vue.set(state.membershipsMap, membership._id, membership)
      }
      state.customerMembershipOrderMap[membership.customer] =
        state.customerMembershipOrderMap[membership.customer] || []

      if (!state.customerMembershipOrderMap[membership.customer].includes(membership._id)) {
        state.customerMembershipOrderMap[membership.customer].push(membership._id)
      }
    },
    [SET_CUSTOMER_MEMBERSHIPS](state, {customerId, memberships}) {
      Vue.set(
        state.customerMembershipOrderMap,
        customerId,
        memberships.map(membership => membership._id)
      )
      //state.customerMembershipOrderMap[customerId] = memberships.map(membership => membership._id)

      for (let membership of memberships) {
        let current = state.membershipsMap[membership._id]
        if (current) {
          Object.assign(current, membership)
        } else {
          Vue.set(state.membershipsMap, membership._id, membership)
        }
      }
    },
    [UPDATE_MEMBERSHIP](state, membership) {
      let current = state.membershipsMap[membership._id]
      if (current) {
        Object.assign(current, membership)
      } else {
        Vue.set(state.membershipsMap, membership._id, membership)
      }
      for (let prop in current) {
        if (membership[prop] === undefined) {
          current[prop] = undefined
        }
      }
    },

    [RESET_MEMBERSHIP](state) {
      state.membershipsMap = {}
      state.customerMembershipOrderMap = {}
    }
  },
  actions: {
    async fetchCustomerMemberships({commit}, customerId) {
      let data = await MembershipsApi.getCustomerMemberships(customerId, false)
      commit(SET_CUSTOMER_MEMBERSHIPS, {customerId, memberships: data})
      return data
    },

    async updateMembership({commit}, {id, data}) {
      const membership = await MembershipsApi.updateMembership(id, data)
      commit(UPDATE_MEMBERSHIP, membership)
      return membership
    },

    async getMembershipById({commit, state}, id) {
      if (!state.membershipsMap[id]) {
        const membership = await MembershipsApi.getMembershipById(id)
        commit(SET_MEMBERSHIP, membership)
      }
      return state.membershipsMap[id]
    },
    reset({commit}) {
      commit(RESET_MEMBERSHIP)
    }
  }
}
